import client from './main-client';

export const getAllNotesApi = (params) => client().get(`/colliers-notes/${params.documentId}/?leadType=${params.leadType}`);

export const addNoteApi = (data) => client().post(`/colliers-notes/?leadType=${data.leadType}`, data);

export const updateNoteApi = (data) => client().patch(`/colliers-notes/${data.leadId}/?leadType=${data.leadType}`, data);

export const removeNoteApi = (data) => client().delete(`/colliers-notes/${data.leadId}/?leadType=${data.leadType}&noteId=${data.noteId}`);
